import { patch } from '../api';

const patchCandidateRecruitCrmInfo = (candidateId, enabled) =>
  patch(`/recruit_crm_pushes/${candidateId}`, {
    data: {
      rcrm_push_enabled: enabled,
    },
  });

export default patchCandidateRecruitCrmInfo;
